import apiFetch from "@wordpress/api-fetch";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
export function convert(temperature, convertTo) {
	return false;
}
// Helper function to set nested values dynamically
// Updated setNestedValue helper function with null/undefined check
export const setNestedValue = (obj, path, value) => {
	// Check if path is null or undefined
	if (path == null) {
		return value; // If no path provided, return the value itself
	}

	const keys = path.split(".");
	const newObj = JSON.parse(JSON.stringify(obj)); // Deep copy to avoid state mutation
	let current = newObj;

	for (let i = 0; i < keys.length - 1; i++) {
		const key = keys[i];

		if (!current[key] || typeof current[key] !== "object") {
			current[key] = {};
		}

		current = current[key];
	}

	current[keys[keys.length - 1]] = value;

	return newObj; // Return full new object
};
const convertToPathArray = (path) => {
	// Step 1: Split by dots (.)
	let parts = path.split(".");

	// Step 2: Find "php" in the array and modify the previous element
	let phpIndex = parts.indexOf("php");
	if (phpIndex > 0) {
		parts[phpIndex - 1] += ".php"; // Append ".php" to the previous element
		parts.splice(phpIndex, 1); // Remove the "php" element
	}
	return parts;
};

export const timeAgo = (inputDate) => {
	// Parse the input date as UTC
	const pastDate = new Date(inputDate + " UTC"); // Append " UTC" to treat the input as GMT
	const now = new Date(); // Current local time

	// Convert both dates to UTC timestamps
	const nowUTC = Date.UTC(
		now.getUTCFullYear(),
		now.getUTCMonth(),
		now.getUTCDate(),
		now.getUTCHours(),
		now.getUTCMinutes(),
		now.getUTCSeconds(),
	);
	const pastDateUTC = Date.UTC(
		pastDate.getUTCFullYear(),
		pastDate.getUTCMonth(),
		pastDate.getUTCDate(),
		pastDate.getUTCHours(),
		pastDate.getUTCMinutes(),
		pastDate.getUTCSeconds(),
	);

	// Calculate the difference in seconds
	const diffInSeconds = Math.floor((nowUTC - pastDateUTC) / 1000);

	const units = [
		{ label: "year", seconds: 60 * 60 * 24 * 365 },
		{ label: "month", seconds: 60 * 60 * 24 * 30 },
		{ label: "week", seconds: 60 * 60 * 24 * 7 },
		{ label: "day", seconds: 60 * 60 * 24 },
		{ label: "hour", seconds: 60 * 60 },
		{ label: "minute", seconds: 60 },
		{ label: "second", seconds: 1 },
	];

	for (const unit of units) {
		const count = Math.floor(diffInSeconds / unit.seconds);
		if (count > 0) {
			return `${count} ${unit.label}${count > 1 ? "s" : ""} ago`;
		}
	}

	return "";
};

export const formatDateTime = (inputDate) => {
	if (inputDate) {
		// Parse the input date string
		const date = new Date(inputDate);

		// Format the date string
		const formattedDate = new Intl.DateTimeFormat("en-US", {
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "numeric",
			minute: "2-digit",
			hour12: true,
		}).format(date);

		return formattedDate;
	} else {
		return "";
	}
};

// Function to ajax post data
export const formDataPost = async (action, data = {}) => {
	try {
		const formData = new FormData();

		// Append action and nonce
		formData.append("action", action);
		const securityNonce = ultimate_security_ajax_obj?.security || "";
		formData.append("security", securityNonce);

		// Append other fields
		Object.entries(data).forEach(([key, value]) => {
			formData.append(key, value);
		});

		// Make the POST request using `url` to avoid wp-json
		const response = await apiFetch({
			url: ultimate_security_ajax_obj.ajax_url,
			method: "POST",
			body: formData,
			parse: false, // IMPORTANT: disable automatic parsing to handle response manually
		});

		const json = await response.json(); // parse manually

		// console.log("AJAX response:", json); // log to see structure

		if (json.success) {
			return json.data || true; // return true or whatever data is needed
		} else {
			throw new Error(json.data?.error_message || "Request failed");
		}
	} catch (error) {
		throw error;
	}
};

// Method 1: Using Regular Expression
export const extractJSONFromHTML = (mixedString) => {
	const hasHTMLContent = /<div[\s\S]*?<\/div>/i.test(mixedString);
	if (hasHTMLContent) {
		// Find the first { and last } to extract JSON
		const jsonMatch = mixedString.match(/\{.*\}/s);
		return jsonMatch ? jsonMatch[0] : "";
	}
	return mixedString;
};

// Method 2: Using DOM Parser
export const extractJSONUsingDOM = (mixedString) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(mixedString, "text/html");

	// Get text content and find the JSON part
	const textContent = doc.body.textContent || "";
	const jsonStart = textContent.indexOf("{");
	const jsonEnd = textContent.lastIndexOf("}") + 1;

	return textContent.slice(jsonStart, jsonEnd);
};

// Method 3: Remove specific div elements
export const removeSpecificDivs = (mixedString) => {
	const hasHTMLContent = /<div[\s\S]*?<\/div>/i.test(mixedString);
	if (hasHTMLContent) {
		// Remove all div elements with id="error"
		return mixedString.replace(/<div id="error">.*?<\/div>/gs, "");
	}
	return mixedString;
};

// Updated urlToArr function
export const urlToArr = () => {
	const location = useLocation();
	const [activePathArr, setActivePathArr] = useState([]);

	useEffect(() => {
		// Get the path from the location
		let path = location.pathname;

		// If using HashRouter, the path is in location.hash
		if (location.hash) {
			path = location.hash.substring(1);
		}

		// Remove leading slash if present
		if (path.startsWith("/")) {
			path = path.substring(1);
		}

		// Remove trailing slash if present
		if (path.endsWith("/")) {
			path = path.slice(0, -1);
		}

		// Split path into segments and filter out empty strings
		const segments = path.split("/").filter((segment) => segment !== "");
		setActivePathArr(segments);
	}, [location]);

	return activePathArr;
};

// Updated useCurrentPageObject function
export const useCurrentPageObject = (urlArray, menuData) => {
	const [currentPageObject, setCurrentPageObject] = useState(null);

	useEffect(() => {
		// Debug what we're working with

		if (!urlArray || urlArray.length === 0 || !menuData) {
			setCurrentPageObject(null);
			return;
		}

		// Find the matching menu item by URL path
		const findPageObject = () => {
			// First, find the top-level menu item
			const topLevelSegment = urlArray[0];
			let foundTopItem = null;

			// Look for the matching top-level item
			for (let i = 0; i < menuData.length; i++) {
				const item = menuData[i];
				const itemPath = item.url.replace(/^\//, ""); // Remove leading slash

				if (itemPath === topLevelSegment) {
					foundTopItem = item;
					break;
				}
			}

			if (!foundTopItem) {
				// console.log(
				// 	`No matching top-level item found for "${topLevelSegment}"`,
				// );
				return null;
			}

			// If we only have one segment, return the top-level page object
			if (urlArray.length === 1) {
				return foundTopItem.page || null;
			}

			// For deeper paths, traverse the sub-menus
			let currentItem = foundTopItem;
			let bestMatchPage = foundTopItem.page; // Start with the top-level page

			if (urlArray.length > 1 && currentItem.sub) {
				// Start from the second segment
				for (let i = 1; i < urlArray.length; i++) {
					const segment = urlArray[i];
					let found = false;

					// Look through the sub-items at the current level
					for (
						let j = 0;
						currentItem.sub && j < currentItem.sub.length;
						j++
					) {
						const subItem = currentItem.sub[j];
						// Extract the last part of the URL to match against the current segment
						const subItemPath = subItem.url.split("/").pop();

						if (subItemPath === segment) {
							currentItem = subItem;
							if (subItem.page) {
								bestMatchPage = subItem.page; // Update best match
							}
							found = true;
							break;
						}
					}

					if (!found) {
						// If we didn't find a match at this level, stop here
						break;
					}
				}
			}

			return bestMatchPage;
		};

		const pageObject = findPageObject();
		setCurrentPageObject(pageObject);
	}, [urlArray, menuData]);

	return currentPageObject;
};

export const validateEmail = (email) => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
};
